'use client'

import { Facebook, Instagram, Linkedin } from 'lucide-react'
import Image from 'next/image'
import { useRouter } from 'next/navigation'

export default function FooterFullScreen() {
  const router = useRouter()

  return (
    <footer className="bg-[#545457] text-[#E2DBD8] w-svw h-full min-h-svh flex flex-col justify-between px-8 md:px-[60px] lg:px-[100px] py-[60px] lg:py-[60px]">
      {/* Logo */}
      <div className="flex-1 flex lg:items-start justify-center">
        <div className="relative w-full aspect-[3/1]">
          <Image
            src="/images/pinnacle-logo-light.png"
            alt="Pinnacle Property Tax"
            fill
            className="object-contain"
            priority
          />
        </div>
      </div>

      {/* Bottom section */}
      <div className="flex flex-col gap-y-6">
        {/* Contact row */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-y-2 gap-x-4">
          <h3 className="text-[16px]! md:text-[22px]! lg:text-[32px] uppercase tracking-[4px] text-center lg:text-left">
            Call or Text Us
            <a href="tel:+15128975477">
              <p className="text-[16px]! text-center lg:text-left font-normal">
                Phone: 512-897-5477
              </p>
            </a>
          </h3>

          <a href="mailto:help@pinnaclepropertytax.com">
            <h3 className="text-[20px]! md:text-[30px]! lg:text-[38px]! xl:text-[48px]! uppercase font-light hover:text-white transition">
              help@pinnaclepropertytax.com
            </h3>
          </a>
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-[#E2DBD8]/40" />

        {/* Copyright & links row */}
        <div className="flex flex-col md:flex-row items-center md:items-start lg:items-center justify-between gap-y-6">
          <div className="flex flex-col text-center md:text-left lg:flex-row lg:items-center gap-x-8 gap-y-2 text-[16px]">
            <div className="flex flex-col md:flex-row">
              <span>&copy; 2026 Pinnacle Property Tax.</span>
              <span> All rights reserved.</span>
            </div>
            <a
              className="hover:text-white transition cursor-pointer"
              onClick={() => {
                router.push('/terms-and-conditions')
              }}
            >
              Terms and Conditions
            </a>
            <a
              className="hover:text-white transition cursor-pointer"
              onClick={() => {
                router.push('/privacy-and-policy')
              }}
            >
              Privacy Policy
            </a>
          </div>

          <div className="flex items-center gap-x-4">
            <a
              href="#"
              aria-label="Instagram"
              className="hover:text-white transition"
            >
              <Instagram size={20} strokeWidth={1.5} />
            </a>
            <a
              href="#"
              aria-label="LinkedIn"
              className="hover:text-white transition"
            >
              <Linkedin size={20} strokeWidth={1.5} />
            </a>
            <a
              href="#"
              aria-label="Facebook"
              className="hover:text-white transition"
            >
              <Facebook size={20} strokeWidth={1.5} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
